import { checkAuth } from './auth';
import makeActionCreator from './makeActionCreator';
import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
    LOGIN_WITH_REQUEST,
    UPDATE_USER_REQUEST,
    CREATE_USER_REQUEST,
    LOGOUT_USER_REQUEST,
    SOCIAL_LOGIN_REQUEST,
    USER_CLEAR_MESSAGE,
    GET_ALL_USERS_REQUEST,
    FETCH_MEMBERSHIP_REQUEST,
    UPDATE_MEMBERSHIP_REQUEST,
    UPDATE_MEMBERSHIP_SUCCESS,
    UPDATE_MEMBERSHIP_FAILURE,
} from '../actionTypes';

export function requestLogin(query) {
    return { query, type: LOGIN_REQUEST };
}

export function loginSuccess(payload) {
    return { type: LOGIN_SUCCESS, payload };
}

export const updateUser = (...payload) =>
    checkAuth({
        type: UPDATE_USER_REQUEST,
        payload,
    });

export const createUser = (payload) => ({
    payload,
    type: CREATE_USER_REQUEST,
});

export const logout = () => ({ type: LOGOUT_USER_REQUEST });

export const socialLogin = (payload) => ({
    payload,
    type: SOCIAL_LOGIN_REQUEST,
});

export const getUsers = (payload) =>
    checkAuth({ payload, type: GET_ALL_USERS_REQUEST });

export const deleteUser = (id) => checkAuth({ id, type: DELETE_USER_REQUEST });

export const deleteUserSuccess = (payload) => ({
    payload,
    type: DELETE_USER_SUCCESS,
});

export const deleteUserFailure = (payload) => ({
    payload,
    type: DELETE_USER_FAILURE,
});

export const clearUserMessage = makeActionCreator(USER_CLEAR_MESSAGE);

export const fetchMembership = () =>
    checkAuth({
        type: FETCH_MEMBERSHIP_REQUEST,
    });

export const updateMembership = (payload) =>
    checkAuth({ payload, type: UPDATE_MEMBERSHIP_REQUEST });

export const updateMembershipSuccess = (payload) => ({
    payload,
    type: UPDATE_MEMBERSHIP_SUCCESS,
});

export const updateMembershipFailure = (payload) => ({
    payload,
    type: UPDATE_MEMBERSHIP_FAILURE,
});

export const loginWithRequest = (payload) => ({
    payload,
    type: LOGIN_WITH_REQUEST,
});
